





































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ToggleSwitch from '@/components/ToggleSwitch.vue'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class MapaPeligroControl extends Vue {
  @Getter('menuPeligro', { namespace: 'mapaPeligro' })
  private menuPeligro!: any;

  private selectedToggle: number[] = [];
  private selectedMap: number = 0;

  @Watch('menuPeligro')
  menuPeligroChanged (menuPeligro: any[]) {
    if (menuPeligro.length > 0) {
      const mapas = this.getMapas()
      mapas.map((index: number) => {
        if (this.isToggle(index)) {
          this.selectedToggle.push(index)
        } else {
          this.selectedMap = index
        }
      })
    }
  }

  getMapas () {
    const mapas = this.$route.query.mapa
    if (typeof mapas === 'string') {
      return [Number(mapas)]
    } else {
      return mapas.map((el: string | null) => Number(el))
    }
  }

  isToggle (index: number) {
    return this.menuPeligro[index] && this.menuPeligro[index].toggle
  }

  updateSelectedMap (mapa: number) {
    this.selectedMap = mapa
  }

  toggleChanged (mapa: number, state: boolean) {
    this.selectedToggle = this.selectedToggle.filter((index) => index !== mapa)
    if (state) {
      this.selectedToggle.push(mapa)
    }
    // TODO: revisar validación de tipos en vue-router
    // @ts-ignore
    this.$router.push({
      query: Object.assign({}, {
        mapa: [this.selectedMap, ...this.selectedToggle]
      })
    })
  }

  get isSubmenuSelected () {
    const isSelected = this.$route.path === '/peligro'
    if (!isSelected) {
      this.selectedToggle = []
      this.selectedMap = 0
    }
    return isSelected
  }

  isToggleSelected (mapa: number) {
    return this.selectedToggle.includes(mapa)
  }
}
